import { getOssSTSCredentials } from '@/api/upload/file'
import OSS from 'ali-oss'
import { getToken, platform } from '@/utils/auth'
import { v4 as uuidv4 } from 'uuid'
import { baseURL } from '@/utils/config'

export class OuchnOss {
  client = undefined
  isPublic = false

  constructor(isPublic) {
    // console.log("当前环境：" + process.env["NODE_ENV"])
    this.isPublic = isPublic
    if (!this.client) {
      this.getOssSTSCredentials_()
    }
  }

  async getOssSTSCredentials_() {
    const _this = this
    await getOssSTSCredentials().then((res) => {
      // console.log('获取签名：' + JSON.stringify(res))
      // alert('securityToken:' + res.data.securityToken)
      if (!res || res.code !== 200) {
        _this.$message.error('获取STS签名错误：' + res.msg)
        return
      }
      var bucket = ''
      if (_this.isPublic) {
        bucket = res.data.pubBucket
      } else {
        bucket = res.data.priBucket
      }
      this.client = new OSS({
        // yourRegion填写Bucket所在地域。以华东1（杭州）为例，yourRegion填写为oss-cn-hangzhou。
        region: res.data.ossReginId,
        // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
        accessKeyId: res.data.accessKeyId,
        accessKeySecret: res.data.accessKeySecret,
        // 从STS服务获取的安全令牌（SecurityToken）。
        stsToken: res.data.securityToken,
        // 填写Bucket名称，例如examplebucket。
        bucket: bucket,
        refreshSTSToken: async function() {
          const stsResult = await getOssSTSCredentials()
          console.log('stsToken刷新', stsResult)
          if (!stsResult || stsResult.code !== 200) {
            _this.$message.error('获取STS签名错误：' + stsResult.msg)
            return
          }
          return stsResult.data
        },
      })
    })
  }

  /**
   * 上传
   * @param file
   * @param options
   *                options.relationId 关联业务ID
   *                options.relationType 关联类型（字符串）
   *
   * @param progressCallback 进度回调，参数：进度0-100
   * @param finishCallback  完成回调
   * @param errorCallback  错误回调
   * @returns {Promise<void>}
   */
  async upload(file, options, progressCallback, finishCallback, errorCallback) {
    var callbackUrl

    if (process.env['NODE_ENV'] === 'development') {
      callbackUrl = 'http://124.133.23.84:10000'
    } else {
      callbackUrl = baseURL
    }
    // console.log("ossCallBackUrl=" + callbackUrl)
    /*const nameArr = file.name.split('.')
    let key = ''
    if (options && options.relationType) {
      key = options.relationType + '/' + uuidv4() + '.' + nameArr[1]
    } else {
      key = uuidv4() + '.' + nameArr[1]
    }*/
    const nameArr = file.name.substring(file.name.lastIndexOf(".") + 1);
    let key = "";
    if (options && options.relationType) {
      key = options.relationType + "/" + uuidv4() + "." + nameArr;
    } else {
      key = uuidv4() + "." + nameArr;
    }
    this.client
      .multipartUpload(key, file, {
        progress: (p, cpt, res) => {
          // 为中断点赋值。
          this.abortCheckpoint = cpt
          console.log(this.abortCheckpoint)
          // 获取上传进度。
          console.log('获取上传进度:' + (p * 100).toFixed(2))

          if (progressCallback instanceof Function) {
            progressCallback((p * 100).toFixed(2))
          }

          // if (p === 1) {
          //   console.log('上传完成...')
          //   debugger
          //   if (finishCallback instanceof Function) {
          //     finishCallback(res)
          //   }
          // }
        },
        callback: {
          // TODO GuoFu 2022年04月30日：设置回调请求的服务器地址。
          url: callbackUrl + '/ouchn-source/file/ossCallBack',
          // 设置回调请求消息头中Host的值，即您的服务器配置的Host值。
          // host: 'oss-cn-hangzhou.aliyuncs.com',
          // 设置发起回调时请求body的值。
          body:
            'bucket=${bucket}&object=${object}&etag=${etag}&size=${size}&mimeType=${mimeType}&imageInfoHeight=${imageInfo.height}&imageInfoWidth=${imageInfo.width}&imageInfoFormat=${imageInfo.format}&relationId=${x:relation_id}&relationType=${x:relation_type}&token=${x:token}&platform=${x:platform}&fileName=${x:file_name}',
          // 设置发起回调请求的Content-Type。
          contentType: 'application/x-www-form-urlencoded',
          // 设置发起回调请求的自定义参数。
          customValue: {
            relation_id: options.relationId,
            relation_type: options.relationType,
            token: getToken(),
            platform: platform,
            file_name: file.name,
          },
        },
      })
      .then((r) => {
        // TODO GuoFu: 2022/5/2 完善状态判断
        if (r.res.status && r.res.status !== 200) {
          if (errorCallback instanceof Function) {
            errorCallback(r)
          }
          return
        }
        // console.log('上传完成服务器回调数据信息：' + JSON.stringify(r))
        const serverData = JSON.parse(r.res.data)
        if (serverData.code === 200) {
          if (finishCallback instanceof Function) {
            finishCallback(serverData.data)
          }
        } else {
          errorCallback(r)
        }
      })
  }

  getDownloadUrl(key, fileName) {
    const response = {
        'content-disposition': `attachment; filename=${encodeURIComponent(fileName)}`
    }
    const url = this.client.signatureUrl(key, { response });
    return url;
  }

  getKey(fullUrl){
      // fullUrl = fullUrl.replace('http://', '')
      // fullUrl = fullUrl.replace(this.region+".",'')
      // fullUrl = fullUrl.replace(this.bucket+".",'')
      // fullUrl=fullUrl.replace("aliyuncs.com","")

    let index = fullUrl.indexOf(".com");
    let result = fullUrl.substr(index + 4,fullUrl.length);
    return result
  }

  downloadByUrl(url,fileName){
      const elink = document.createElement('a')

      elink.href = url
      elink.download = fileName

      elink.style.display = 'none'

      document.body.appendChild(elink)

      setTimeout(() => {

          elink.click()

          document.body.removeChild(elink)

      }, 66)
  }

  /***
   * 此方法用来实现对OSS文件重命名后下载
   * @param fullUrl  当前完整的url，会在方法内除去域名等信息，得到key
   * @param newFileName 新的文件名
   */
  downloadByFullUrl(fullUrl,newFileName){
      const key=this.getKey(fullUrl)
      const newUrl=this.getDownloadUrl(key,newFileName)
      this.downloadByUrl(newUrl,newFileName)
  }
}

